import { Box, Paper, Typography, Grid } from '@mui/material';
import React from 'react';

export default function StudentDetails({ student }) {
  const studentInfo = [
    { label: 'Name of the Student', value: student?.student_name },
    { label: 'Name of the CRO', value: student?.cro_name },
    { label: 'Class', value: student?.student_class },
    // { label: 'Name of the Tutor', value: student?.tutorName },
    { label: 'Admission Number', value: student?.admn_no },
    { label: 'Course Name', value: student?.course_name },
  ];

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        mb: 2,
        borderRadius: 2,
        mt: 3,
      }}
    >
      <Typography variant="subtitle2">Student & Course Details</Typography>
      <Box
        sx={{
          backgroundColor: '#f9fafb',
          borderRadius: 2,
          p: 2,
          border: '1px solid #e0e0e0',
          mt: 1,
        }}
      >
        <Grid container spacing={2}>
          {studentInfo.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#555' }}>
                  {item.label}:
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {item.value || '--'}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  );
}
